import { useQuery } from '@tanstack/react-query'

import { einvoiceApi } from '@/lib/api/einvoice-api'
import { einvoiceKeys } from '@/hooks/use-einvoice-query'

/** Whether MISA keeps an unnumbered draft for this order, read with the
 *  viewer's own MISA account. Short cache: the answer only changes when someone
 *  acts, and each read is a call to MISA. */
export function useEInvoiceMisaState(orderId: string, enabled: boolean) {
    return useQuery({
        queryKey: einvoiceKeys.misaState(orderId),
        queryFn: async () => (await einvoiceApi.misaState(orderId)).data,
        enabled,
        staleTime: 60_000,
        retry: false,
    })
}
